import { FechaTimestampPipe } from "./../pipes/fecha-timestamp.pipe";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class HistorialHelper {
  constructor(private fechaTimestampPipe: FechaTimestampPipe) { }

  dropDownList(dataFuente: any[], subDominio?: string): { id: string; description: string }[] {
    let list: { id: string;"data.header":string; description: string; fecha?: Date; fechaFormat?:string}[] = [];

    dataFuente.forEach((data) => {
      let fechaParse: any;
      let fechaTimeStamp: any = "";
      let hours:any = "";
      if (subDominio == "DELINQUENCY_BED_EXCH") {
        fechaParse = this.fechaTimestampPipe.transform(data.insertion_date);
        fechaTimeStamp = this.fechaTimestampPipe.transform(data.journalingTimestamp);
        hours = new Date(data.journalingTimestamp).getHours();
      } else {
        fechaParse = this.fechaTimestampPipe.transform(data.journalingTimestamp);
        hours = new Date(data.journalingTimestamp).getHours();
      }

      let unirFechaBed: any = "";
      if (subDominio == "DELINQUENCY_BED_EXCH") {
        unirFechaBed = ' (' + fechaTimeStamp + ')'
      }
      const [datePart, timePart] = fechaParse.split(" ");
      const [day, month, year] = datePart.split("/");
      const [hour, minute] = timePart.split(":");

      list.push({
        id: data.journalingTimestamp,
        description: fechaParse + unirFechaBed,
        "data.header":data["data.header"],
        fecha: new Date(
          parseInt(year),
          parseInt(month) - 1,
          parseInt(day),
          parseInt(hour),
          parseInt(minute)
        ),
        fechaFormat: `${datePart}${unirFechaBed} ${hours}:${minute}`
      });
    });

    if (subDominio == "DELINQUENCY_BED_EXCH") {
      list.sort((a: any, b: any) => {
        if (a.id !== b.id) {
          return Number(b.id) - Number(a.id); // timestamp mas reciente primero
        } else {
          return a.fecha.getTime() - b.fecha.getTime(); // fecha mas antiguo primero
        }
      });
      let registroFinal: { id: string; description: string; fecha?: Date; }[] = [];
      registroFinal = list;
      return registroFinal;
    } else {
      return list.sort((a: any, b: any) => b.fecha.getTime() - a.fecha.getTime());
    }
  }

  generateListHistModal(history: any[],list: any[]){
    return history.map(hist=>{
      const matchItem = list.find(histList => histList.id === hist.journalingTimestamp);

      return {
        ...hist,
        journalingTimestampFormat: matchItem ? matchItem.fechaFormat:null
      }
    }).sort((a: any, b: any) => Number(b.journalingTimestamp) - Number(a.journalingTimestamp));
   
  }
}